import { api } from '../api/client';
import { ReservedStockItem } from '../types';

export const getReservedStock = async (): Promise<ReservedStockItem[]> => {
  return api.get<ReservedStockItem[]>('/reserved-stock');
};
